<template>
  <TrainerLayout>
    <section>
      <div class="flex justify-between items-center px-2">
        <h3 class="py-4 md:text-2xl font-bold uppercase">Notification</h3>
        <button
          class="w-32 py-1 text-sm bg-green-light ring-1 text-white rounded-lg"
          v-if="isActive.length"
          @click.prevent="onClearSelectedClick"
        >
          Mark as read
        </button>
        <div v-else>
          <button
            class="w-32 py-1 text-sm bg-green-light ring-1 text-white rounded-lg"
            v-if="notifications.length"
            @click.prevent="handleAllRead"
          >
            Mark all as read
          </button>
        </div>
      </div>
      <div v-if="notifications.length">
        <div v-for="n in notifications" :key="n.id">
          <div
            class="flex items-center bg-white shadow px-2 py-1 rounded ring-1 ring-gray-300 mb-1"
            :class="{
              'bg-blue-lightest': isActive.includes(n.id.toString()),
              'opacity-50': n.is_active == INACTIVE,
            }"
          >
            <input
              type="checkbox"
              :value="n.id"
              @click="handleChecked"
              :disabled="n.is_active == INACTIVE ? true : false"
            />
            <NotificationList
              :title="n.data && n.data.title"
              :body="n.data && n.data.body"
              :action="n.data && n.data.action"
              :thumbnail_url="n.thumbnail_url"
              :isChatNotification="isChatNotification"
              :notificationType="n.type"
              :user="userType"
            />
          </div>
        </div>
      </div>
      <div class="ml-2" v-else>No unread notification</div>
    </section>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import NotificationList from "@/components/notification/NotificationList";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Notification",
  components: {
    TrainerLayout,
    NotificationList,
  },
  props: {
    isChatNotification: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: [],
      userType: "Trainer",
      INACTIVE: 0,
    };
  },
  computed: {
    ...mapGetters(["notifications"]),
  },
  methods: {
    ...mapActions(["notificationDestroy", "getNotifications"]),

    async handleAllRead() {
      var array = [];
      var checkboxes = document.querySelectorAll(
        "input[type=checkbox]:enabled"
      );

      for (var i = 0; i < checkboxes.length; i++) {
        array.push(checkboxes[i].value);
      }
      if (array.length) {
        await this.notificationDestroy({ ids: array });
        await this.getNotifications();
      }
    },

    handleChecked() {
      var array = [];
      var checkboxes = document.querySelectorAll(
        "input[type=checkbox]:checked"
      );

      for (var i = 0; i < checkboxes.length; i++) {
        array.push(checkboxes[i].value);
      }
      this.isActive = array;
    },

    async onClearSelectedClick() {
      await this.notificationDestroy({ ids: this.isActive });
      await this.getNotifications();
    },
  },
};
</script>